import { LanguageCode } from "src/utils/localization/languages/types";
import { INavLink, INavLinks } from "components/HeaderNavBar/type";

export interface INavigationLinks {
  search: string;
  primaryLinks: INavLinks;
  secondaryLinks: INavLinks;
  serviceLinks: {
    raq: INavLink;
    brochures: INavLink;
  };
  footerLinks: INavLinks;
  subFooterLinksLinks: INavLinks;
  corporateIncentivePrimaryLinks: INavLinks;
}

const getUrlsByLanguage: (language: LanguageCode) => INavigationLinks = (
  language
) => {
  switch (language) {
    case "en":
      return require("./en.json");
    case "de":
      return require("./de.json");
    case "pt-br":
      return require("./pt-br.json");
    case "es":
      return require("./es.json");
    case "fr":
      return require("./fr.json");
    default:
      return require("./en.json");
  }
};

export default getUrlsByLanguage;
